import { NotchProvider } from './notch-provider'
import { StepProvider } from './step-provider'

export interface ContextProviderProps {
  children: React.ReactNode
}

export const ContextProvider = ({ children }: ContextProviderProps) => {
  return (
    <NotchProvider>
      <StepProvider>{children}</StepProvider>
    </NotchProvider>
  )
}
